"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconKrakenzpumps = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 1.45c5.827 0 10.55 4.723 10.55 10.55 0 5.827-4.723 10.55-10.55 10.55-5.827 0-10.55-4.723-10.55-10.55C1.45 6.173 6.173 1.45 12 1.45zm0 1.5a9.05 9.05 0 100 18.1 9.05 9.05 0 000-18.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 6.197a5.803 5.803 0 110 11.606 5.803 5.803 0 010-11.606zm0 1.5a4.303 4.303 0 100 8.606 4.303 4.303 0 000-8.606zm-7.611.821a.75.75 0 011.38.588A7.366 7.366 0 005.18 12c0 .766.116 1.515.342 2.23a.75.75 0 11-1.43.452A8.889 8.889 0 013.68 12c0-1.211.243-2.39.708-3.482z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.906 6.543a.75.75 0 011.06.024 7.932 7.932 0 012.208 5.501 7.93 7.93 0 01-2.068 5.351.75.75 0 11-1.11-1.009 6.43 6.43 0 001.678-4.342c0-1.687-.649-3.27-1.792-4.464a.75.75 0 01.024-1.06zM2.078 2.863a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zm19.535 0a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zM2.078 22.583a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zm19.535 0a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconKrakenzpumps, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;